import { useEffect, useState, useRef } from "react";
import {
    Box, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Button,
    FormControlLabel, Grid, IconButton, Snackbar, TextField, Typography
} from "@mui/material";
import { Redirect } from "react-router-dom";
import { getApiUrl } from "../../services/api_service";
import { Alert, Autocomplete } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReactInputMask from "react-input-mask";
import { bodyBg, mainGrid, orangecolor, pcolor, rcolor, whitecolor } from "../../style2";


export default function MakeReferral(props) {
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [surName, setSurName] = useState('');
    const [nhsNumber, setNHSNumber] = useState('');
    const [dob, setDOB] = useState();
    const [address, setAddress] = useState('');
    const [postCode, setPostCode] = useState('');
    const [parentName, setParentName] = useState('');
    const [parentEmail, setParentEmail] = useState('');
    const [proposedSubmissionDate, setProposedSubmissionDate] = useState(null);
    const [reminder, setReminder] = useState(1);
    const [redirect, setRedirect] = useState('');
    const [addresses, setAddresses] = useState([]);
    const [showNHSConfirmationModal, setShowNHSConfirmationModel] = useState(false);
    const [nhsChanged, setNHSChanged] = useState(null);
    const nhsRef = useRef(null);
    const forenameRef = useRef(null);



    useEffect(() => {
        if (forenameRef.current) {
            forenameRef.current.focus();
        }
    }, []);


    useEffect(() => {
        if (props.form !== undefined && props.form !== null) {
            props.form.pages.map((p) => {
                p.questions.map(q => {
                    if (q.text.toLowerCase().indexOf("dob") > -1 || q.text.toLowerCase().indexOf("date of birth") > -1) {
                        setDOB(q.answer);
                    }
                })
            })
        }
    }, [props]);

    useEffect(() => {
        const myHeaders = new Headers();

        fetch(`${getApiUrl()}/referralapp/addresses?code=${postCode}`, {
            method: 'GET',
            headers: myHeaders
        }).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    if (data != null && data.results !== null) {
                        let temp = [];
                        data.results.map(item => {
                            let a = `${item.line_1} ${item.line_2} ${item.line_3} ${item.line_4} ${item.locality} ${item.town_or_city} ${item.county}`;
                            a = a.replace(/\s\s+/g, ' ')
                            temp.push(a);
                        });
                        //console.log(temp);
                        setAddresses(temp);
                    }

                }).catch(err => {
                    console.log(err);
                    setAddresses([]);
                })
            }
            else {
                response.json().then(data => {
                    console.log(data);
                }).catch(err => {
                    console.log(err);
                })
            }
        })
    }, [postCode])

    const saveData = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/referralapp/addpatient?code=${props.orgCode}`, {
            method: 'POST',
            body: JSON.stringify({
                firstName, surName, nhsNumber, dob,
                address, postCode, parentName, parentEmail,
                proposedSubmissionDate, reminder,
                form: props.form
            }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setSuccess('Patient referred.');
                    setRedirect(`/referral/patients/${props.orgCode}`);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box pt={1} sx={{ ...bodyBg, marginTop: "5px", }} p={5}>
            <Box sx={{ ...mainGrid, background: whitecolor, marginTop: "20px", padding: "2rem 3rem" }}>
                <form onSubmit={(e) => { 
                    e.preventDefault(); 
                    saveData(); 
                    }}>
                    <Grid container>
                        <Grid xs={6} item>
                            <Box pl={3} pr={6}>
                                <Typography variant="h5" sx={{ fontWeight: "bold", color: rcolor, marginBottom: "2rem" }}>Create Child’s  Profile</Typography>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Forename*</label>
                                    <TextField inputProps={{ maxLength: "50" }} inputRef={forenameRef} sx={{ border: `1px solid ${pcolor}`, borderRadius: 2, width: "80%" }} required={true} variant="outlined" placeholder="" fullWidth value={firstName} onChange={(e) => {
                                        setFirstName(e.target.value);
                                    }} />
                                </Box>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Surname*</label>
                                    <TextField inputProps={{ maxLength: "50" }} sx={{ border: `1px solid ${pcolor}`, borderRadius: 2, width: "80%" }} required={true} variant="outlined" placeholder="" fullWidth value={surName} onChange={(e) => {
                                        setSurName(e.target.value);
                                    }} />
                                </Box>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>NHS Number*</label>
                                    <ReactInputMask
                                        mask="999-999-9999"
                                        value={nhsNumber}
                                        fullWidth
                                        required={true}
                                        style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "80%" }}
                                        onChange={(e) => {
                                            if (e.target.value !== nhsNumber) {
                                                setNHSChanged(true);
                                            } else {
                                                setNHSChanged(false);
                                            }
                                            setNHSNumber(e.target.value.replace(/_/g, ""));
                                        }} onBlur={(e) => {
                                            setTimeout(() => {
                                                if (nhsNumber.length === 12 && nhsChanged) {
                                                    setShowNHSConfirmationModel(true);
                                                    setNHSChanged(false);
                                                }
                                            }, 400);

                                        }}>
                                        {(inputProps) => <TextField {...inputProps} inputRef={nhsRef} variant="outlined" />}
                                    </ReactInputMask>
                                    <Dialog
                                        open={showNHSConfirmationModal}
                                        onClose={(event, reason) => {
                                            if (reason === "backdropClick") {
                                                return;
                                            }

                                            setShowNHSConfirmationModel(false);
                                        }}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description" disableRestoreFocus={true}>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                <Box style={{ textAlign: "center" }}>
                                                    <ReportGmailerrorredIcon style={{ fontSize: "2.6rem" }} /> </Box>
                                                <Typography style={{ fontSize: "1.6rem", marginBottom: "10px", textAlign: "center" }}>
                                                    Confirmation!
                                                </Typography>
                                                <Typography style={{ fontSize: "1.2rem", textAlign: "center" }}>Is the NHS Number correct?<br />
                                                    {nhsNumber}</Typography>
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => {
                                                setShowNHSConfirmationModel(false);
                                                if (nhsRef.current) {
                                                    try {
                                                        setTimeout(() => {
                                                            nhsRef.current.focus();
                                                        }, 400);

                                                    } catch (err) { console.log(err); }
                                                }

                                            }}>No</Button>
                                            <Button onClick={() => { setShowNHSConfirmationModel(false); }} autoFocus>
                                                Yes
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Box>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>D.O.B*</label>

                                    <TextField sx={{ border: `1px solid ${pcolor}`, borderRadius: 2, width: "80%" }} inputProps={{ type: 'date' }} variant="outlined" required={true} label="" placeholder="" fullWidth value={dob} onChange={(e) => {
                                        setDOB(e.target.value);
                                    }} />
                                </Box>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Postcode*</label>
                                    <TextField inputProps={{ maxLength: "8" }} sx={{ border: `1px solid ${pcolor}`, borderRadius: 2, width: "80%" }} variant="outlined" required={true} label="" placeholder="" fullWidth value={postCode} onChange={(e) => {
                                        setPostCode(e.target.value);
                                    }} />
                                </Box>
                                <Box mb={4}>
                                    <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Home Address*</label>
                                    <Autocomplete
                                        options={addresses}
                                        value={address}
                                        freeSolo
                                        inputValue={address}
                                        onInputChange={(e, newInputValue) => {
                                            setAddress(newInputValue);
                                        }}
                                        onChange={(e, newValue) => {
                                            setAddress(newValue || '');
                                        }}
                                        renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, maxLength: 200}}
                                            variant="outlined" required={true} multiline={true} label="" placeholder="" fullWidth style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "80%" }} />}
                                    />
                                </Box>

                            </Box>
                        </Grid>
                        <Grid xs={6} item>
                            <Typography variant="h5" style={{ fontWeight: "bold", color: rcolor, marginBottom: "2rem" }}>Invite Parent or Carer</Typography>
                            <Box mb={4}>
                                <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Parent Name*</label>
                                <TextField inputProps={{ maxLength: "50" }} style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "80%" }} variant="outlined" required={true} label="" placeholder="" fullWidth value={parentName} onChange={(e) => {
                                    setParentName(e.target.value);
                                }} />
                            </Box>
                            <Box mb={4}>
                                <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Parent Email*</label>
                                <TextField inputProps={{ maxLength: "100", type: "email" }} style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "80%" }} variant="outlined" required={true} label="" placeholder="" fullWidth value={parentEmail} onChange={(e) => {
                                    setParentEmail(e.target.value);
                                }} />
                            </Box>
                            <Box mb={4}>
                                <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}> Proposed submission date (optional)</label>
                                <TextField style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "80%" }} inputProps={{ type: 'date' }} variant="outlined" label="" placeholder="" fullWidth value={proposedSubmissionDate} onChange={(e) => {
                                    setProposedSubmissionDate(e.target.value);
                                }} />
                            </Box>
                            <Box mb={4}>
                                <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}> Reminder</label>
                                <FormControlLabel control={<Checkbox value="1" defaultChecked={reminder === 1} onChange={(e) => {
                                    if (e.target.checked) {
                                        setReminder(1);
                                    } else {
                                        setReminder(null);
                                    }
                                }} />} label="Weekly" />
                            </Box>
                            <Box mb={4} style={{ fontSize: "1.1rem" }}>
                                Parent/carer will be sent an email invite to
                                download EMC Mobile app and complete
                                the questionniare using the app. </Box>

                        </Grid>
                    </Grid>
                    {error !== "" ? <Box mb={1} mt={1}><Alert severity="error">{error}</Alert></Box> : null}
                    <Snackbar open={success !== ""} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={60000} onClose={() => { setSuccess(''); }}
                        message={success} action={<> <IconButton size="small" aria-label="close" color="inherit" onClick={() => { setSuccess('') }}> <CloseIcon fontSize="small" /> </IconButton> </>}
                    />
                    <Box sx={{ display: "flex", justifyContent: 'center', flexDirection: 'row', padding: 3 }}>
                        <Button type="button" onClick={() => {
                            setRedirect(`/referral/whoareyou/${props.orgCode}`);
                        }} disabled={loading} style={{
                            fontSize: "1.1rem", height: "40px", width: "150px", marginRight: "30px", borderRadius: 15,
                            background: whitecolor, border: `2px solid ${orangecolor}`, textTransform: "capitalize"
                        }} >Cancel</Button>

                        <Button type="submit" style={{ background: orangecolor, fontSize: "1.1rem", height: "40px", width: "150px", borderRadius: 15, color: whitecolor, textTransform: "capitalize" }}
                            disabled={loading}>
                            {loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Submit
                        </Button>

                    </Box>
                </form>
            </Box>
        </Box>;
}